import IframeResizer from "iframe-resizer-react";
import React, { useRef, useEffect, useState, useCallback } from "react";
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { LoaderExt } from "gw-components-platform-react";
import appConfig from "app-config";
import { getIconClasses } from "@jutro/components";
import styles from './PaymentComponentExt.module.scss';

function BluePay(props) {
   
    
    
    const [isLoading, setIsLoading] = useState(false);
    const { history ,setCallback} = props;   
    const creditCard=props.creditCard; 
    const accountNumber = props.accountNumber;
    const email = props.userInfo.email;
    const amountDue = props.amountDue;
    const [creditCardInfo, setCreditCardInfo] = useState({});
    const { authHeader } = useAuthentication();
    const ref = useRef(null);
    const [messageData, setMessageData] = useState();
    const[title,setTitle]=useState(false);
    const onResized = (data) => setMessageData(data);
    const { env } = appConfig;
    const invoiceStreamId= props?.history?.location?.state?.invoiceStreamID;
    const invoiceStreamName=props?.history?.location?.state?.invoiceStreamName;
    const multiStreamDropDownArray = props?.multiStreamDropDownArray;
    
    const prefix = _.get(env, "DEPLOYMENT_URL");
    
    const { AccountBillingDetailsService: BillingService } = useDependencies(
        "AccountBillingDetailsService"
    );
    
    const onMessage = (data) => {
        setMessageData(data);
    };
    
    useEffect(() => {
        window.sessionStorage.setItem("invoiceName", invoiceStreamName)
        window.sessionStorage.setItem("invoiceStreamId", invoiceStreamId)
        BillingService.getCreditCardProperties_Ext(accountNumber, authHeader).then(
            (res) => {                            
                res.multiStreamDropDownArray = multiStreamDropDownArray;
                setCreditCardInfo(res);
                
            }
        );
    }, []);

    // useEffect(()=>{
    //     history.push({
    //         pathname: ``,
    //         state: {
    //             invoiceStreamId:invoiceStreamId,
    //             invoiceStreamName:invoiceStreamName
    //         },
    //     });
    // },[history, invoiceStreamId, invoiceStreamName])


    useEffect(()=>{
        if(messageData!==undefined&&messageData.message)
        {
            if(messageData.message.title==='cancel')
            {
                history.push({
                    pathname: `/billing-summary`,
                    state: {
                        redirectPath: "/",
                        message: "CancelPayment",
                    },
                });
            }
            else if(messageData.message.title === "getTokenAndSubmit")
            {
                // setIsLoading(true);
                BillingService.generatePaymentTokenForAgents(accountNumber,authHeader).then((res) => {
                 
                    ref.current.sendMessage(
                        { title: "setTokenAndSubmit", value: res },
                        `${prefix}/`
                    );
                    // setLoadingState(false);
                });
            }
            else if(messageData.message.title === "ready"&&title===false){
                setTitle(true);
               

            }
            else if(messageData.message.title === "hideSourceDropdown"&&title===true)
            {
                setTitle(false);             
                setCallback('hideSourceDropdown')
               creditCard(true);
                
            }
            else if(messageData.message.title === "showSourceDropdown"&&title===false)
            {
                setTitle(true);   
                setCallback('showSourceDropdown')
                creditCard(false);
                
            }
        }

    },[BillingService, accountNumber, authHeader, creditCard, history, messageData, prefix, setCallback, title])

    
    
    const url = () => {
        
        
        const bluePayHost = "https://secure.bluepay.com/interfaces/shpf?";
        const argsArray = [];
        //
        // bp10emu API
        //
        argsArray.push(`MERCHANT=${creditCardInfo.merchant}`);
      
        // argsArray.push(`DBA=${creditCardInfo.dba}`);
        argsArray.push(`DBA=${`${creditCardInfo.dba}  ${creditCardInfo.multiStreamDropDownArray}`}`);
        argsArray.push(`TRANSACTION_TYPE=${`${creditCardInfo.transactionType}`}`);
        // argsArray.push(`TRANSACTION_TYPE=${creditCardInfo.invoiceStreamName}`);
        argsArray.push(`MODE=${creditCardInfo.mode}`);
        argsArray.push(`TAMPER_PROOF_SEAL=${creditCardInfo.tpsKey}`);
        argsArray.push(`TPS_DEF=${creditCardInfo.tpsDef}`);
        argsArray.push(`RESPONSEVERSION=${creditCardInfo.responseVersion}`);
        //
        // SHPF API
        //
        argsArray.push(`SHPF_FORM_ID=${creditCardInfo.shpfFormId}`);
        argsArray.push(`SHPF_ACCOUNT_ID=${creditCardInfo.shpfAccountId}`);
        argsArray.push(`SHPF_TPS=${creditCardInfo.shpfKey}`);
        argsArray.push(`SHPF_TPS_DEF=${creditCardInfo.shpfTpsDef}`);
        argsArray.push(`invoiceName=${invoiceStreamName}`);
        
        //
        // CPMI API
        //
        const finalAmount = parseFloat(Math.round(amountDue * 100) / 100).toFixed(
            2
        );
        if (finalAmount > 0) argsArray.push(`AMOUNT=${finalAmount}`);
        else argsArray.push(`AMOUNT=`);
      
        argsArray.push(`EMAIL=${`${email }  ${ accountNumber}`}`);
        argsArray.push(`NAME1=`);
        argsArray.push(`NAME2=`);
        argsArray.push(`CUSTOM_ID=${creditCardInfo.customId1}`);
        argsArray.push(`ORDER_ID=UNUSED`);            
        
        // argsArray.push(`APPROVED_URL=${creditCardInfo.approvedUrl}`);
        // argsArray.push(`DECLINED_URL=${creditCardInfo.declinedUrl}`);
        // argsArray.push(`MISSING_URL=${creditCardInfo.missingUrl}`);
      
        argsArray.push(`APPROVED_URL=${prefix}/account-management/paymentinfo`);
        argsArray.push(`DECLINED_URL=${prefix}/account-management/paymentinfo`);
        argsArray.push(`MISSING_URL=${prefix}/account-management/paymentinfo`);
      
        const appendArgs = argsArray.join("&");
        const encodedURL = encodeURI(bluePayHost + appendArgs);
      
        return encodedURL;
    };
      
          
      
    
    

    if (isLoading) {
        
        return <LoaderExt loaded={!isLoading} />;
    }

    if (isLoading) {
        return (
            <>
                <LoaderExt loaded={!isLoading} />
                <IframeResizer
                    className={title?styles.bluepay:styles.bluepayHeight}
                    log
                    inPageLinks
                    forwardRef={ref}
                    src={url()}
                    onResized={onResized}
                    onMessage={onMessage}
                    width="100%"
                    scrolling="no"
                    checkOrigin="false"
                    style={{ border: "0px"  }}
                />
            </>
        );
    }
      
    return (
        <IframeResizer
            // className={styles.bluepay}
            className={title?styles.bluepay:styles.bluepayHeight}
            log
            inPageLinks
            forwardRef={ref}
            src={url()}
            onResized={onResized}
            onMessage={onMessage}
            width="100%"
            scrolling="no"
            checkOrigin="false"
            style={{ border: "0px"  }}
        />
    );

    
}

BluePay.propTypes = {
    history: PropTypes.shape({
        location: PropTypes.shape({
            state: PropTypes.shape({
                redirectPath: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
        push: PropTypes.func.isRequired,
    }).isRequired,
};

export default withRouter(BluePay);

